import { render, staticRenderFns } from "./self-service.vue?vue&type=template&id=17a0f7a0&"
import script from "./self-service.vue?vue&type=script&lang=js&"
export * from "./self-service.vue?vue&type=script&lang=js&"
import style0 from "./self-service.vue?vue&type=style&index=0&id=17a0f7a0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17a0f7a0')) {
      api.createRecord('17a0f7a0', component.options)
    } else {
      api.reload('17a0f7a0', component.options)
    }
    module.hot.accept("./self-service.vue?vue&type=template&id=17a0f7a0&", function () {
      api.rerender('17a0f7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/self-review/self-service.vue"
export default component.exports